import React, { useEffect, useState } from "react";

/// Image
import profile from "../../../images/profile/userIcon.png";
import ukLogo from "../../../images/uklogo.png";
import { Dropdown } from "react-bootstrap";
import LogoutPage from "./Logout";
import Profile from "./Profile";
import { useNavigate } from "react-router-dom";
import Bell from "../../../icons/flaticon/bell.png";
import { notificationListApi, notificationUpdateApi } from "../../../services/userApiService/userService";
import { NavMenuToggle } from "./NavHader";

const Header = ({ onNote, hideHamburger }) => {
  const [notificationCount, setNotificationCount] = useState();

  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  const loginData = JSON.parse(localStorage.getItem("login_Details"));
  const userType = localStorage.getItem("user_type");
  const navigate = useNavigate();
  const loginDetails = localStorage.getItem("login_Details");
  const loginFullDetails = JSON.parse(loginDetails);

  const handleBellIconClickEvent = async () => {
    try {
      // 🔹 Call the POST API to update notification status
      const response = await notificationUpdateApi();
      console.log("Notification update response:", response);

      // Optionally, reset notification count to 0 after marking as read
      setNotificationCount(0);

      // 🔹 Then navigate to the notification page
      navigate("/user-grievance-management/notification");
    } catch (error) {
      console.error("Error updating notifications:", error);
      // You can still navigate if needed, even if API fails
      navigate("/user-grievance-management/notification");
    }
  };
  const getNotificationListApi = async () => {
    try {
      const response = await notificationListApi();
      setNotificationCount(response.data.count)

    } catch (error) {
      console.error('notification error:', error);
    }

  }
  useEffect(() => {
    if (loginData?.type === "user" || userType === "user") {
      getNotificationListApi();
    }
  }, [loginData?.type, userType]);

  return (
    <div className="header border-bottom navbar-height border-bottom-left-right-round white">
      <div className="header-content">
        <div
          className={`d-flex align-items-center ${hideHamburger ? "" : "d-lg-none"}`}
          style={{ gap: "0.5rem", flexShrink: 0 }}
        >
          {!hideHamburger && (
            <button
              className="hamburger-btn"
              onClick={NavMenuToggle}
              aria-label="Toggle navigation"
            >
              <i className="fa fa-bars fa-lg" />
            </button>
          )}
          <img src={ukLogo} alt="logo" style={{ height: "32px", width: "auto" }} />
        </div>
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-end align-items-center gap-3">
            <div className="header-left">
              <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize" }}
              ></div>
            </div>
            <ul className="navbar-nav header-right main-notification">
              {loginData?.type === "user" || userType === "user" ? (
                <div className="my-auto">
                  <div className="p-2 rounded-full cursor-pointer hover:bg-gray-200 transition-colors duration-200 outline-none ring-0 focus:outline-none focus:ring-0" onClick={handleBellIconClickEvent}>
                    <img
                      src={Bell}
                      alt="Notifications"
                      style={{ width: "2rem" }}
                    />
                    {/* 🔴 Show red dot only when count > 0 */}
                    {notificationCount > 0 && (
                      <span className="notification-dot"></span>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}

              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="nav-link i-false c-pointer"
                  role="button"
                  data-toggle="dropdown"
                >
                  <img src={profile} width={20} alt="user-image" />

                </Dropdown.Toggle>
                <Dropdown.Menu
                  align="right"
                  className="mt-3 dropdown-menu dropdown-menu-end"
                >
                  <LogoutPage />
                  {loginData?.type === "user" || userType === "user" ? (
                    <Profile />
                  ) : (
                    ""
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </ul>
            <div className="d-flex align-items-center gap-2">
              <div className="brand-title">
                <span className="brand-sub-title">
                  {loginFullDetails?.user?.name}
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
